import(/* webpackMode: "eager", webpackExports: ["default"] */ "C:\\Users\\RYAN-NB\\Documents\\MACNESIA\\macspace.id\\src\\app\\layanan\\[...slug]\\detailLayanan.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "C:\\Users\\RYAN-NB\\Documents\\MACNESIA\\macspace.id\\src\\app\\layanan\\[...slug]\\layanan.tsx");
